/** @jsxImportSource @emotion/react */
import { h100css } from "assets/css/dimensions";
import { gap8Css } from "pages/admin/templates/Header/index.css";
import PropTypes from "prop-types";

export default function ActionsCell({ row, table }) {
  const { onEdit, deleteRule } = table.options.meta;

  return (
    <div css={[h100css, gap8Css]} className="flex-a-c">
      <button type="button" onClick={() => onEdit(row.original)}>
        Edit
      </button>
      /
      <button type="button" onClick={() => deleteRule(row.original.id)}>
        Delete
      </button>
    </div>
  );
}

ActionsCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  table: PropTypes.shape({
    options: PropTypes.shape({
      meta: PropTypes.shape({
        onEdit: PropTypes.func.isRequired,
        deleteRule: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};
